import * as React from "react";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import {
  Stack,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Button,
  InputAdornment,
  IconButton,
  Tooltip,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import * as Yup from "yup";
import styles from "./UpdateMobileEmailModal.module.scss";

import { useState } from "react";

import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import {
  GetEmailOTPAPICall,
  GetMobileOTPAPICall,
  ResendEmailOTPAPICall,
  ResendMobileOTPAPICall,
} from "../EmailMobileUpdateAPICalls";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import otpIcon from "../../../Components/assets/Images/otpIcon.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    borderRadius: "12px",
    margin: "10px",
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{
        margin: "auto",
        padding: "20px 0px 10px 0px",
        display: "flex",
        alignItems: "center",
        fontSize: "20px",
        fontWeight: 500,
        borderBottom: "1px solid #e5e7eb",
        width: "90%",
      }}
      {...other}
    >
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <ArrowBackIosIcon style={{ fontSize: "16px", color: "#1F2937" }} />
        </IconButton>
      ) : null}
      {children}
    </DialogTitle>
  );
}

interface Props {
  open: boolean;
  handleClose: any;
  value?: any;
  handleSubmitData: any;
  data: any;
  ProgressEmialData: any;
  ProgressMobileData: any;
}
const UpdateMobileSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Mobile Number is Required")
    .min(10, "Mobile number must be  10 Numbers"),
  otp: Yup.string().required("OTP is Required"),
});
const UpdateEmailSchema = Yup.object().shape({
  email: Yup.string()
    .required("Email is Required")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Enter Valid Email"),
  otp: Yup.string().required("OTP is Required"),
});

export default function UpdateMobileEmailModal({
  open,
  handleClose,
  handleSubmitData,
  data,
  value,
  ProgressEmialData,
  ProgressMobileData,
}: Props) {
  const [errorMobileMessage, setMobileErrorMessage] = useState("");
  const [errorEmailMessage, setEmailErrorMessage] = useState("");
  const [requestId, setRequestId] = useState("");
  const [displayMobileOtp, setDisplayMobileOtp] = useState(false);
  const [displayEmailOtp, setDisplayEmailOtp] = useState(false);
  const [emailError, setEmailerror] = useState("");
  const [mobileError, setmobileerror] = useState("");
  const [mobileSuccess, setmobileSuccess] = useState("");
  const [emailSuccess, setemailSuccess] = useState("");
  const [mobileResendOtp, setMobileResendOtp] = useState(false);
  const [emailResendOtp, setEmailResendOtp] = useState(false);
  const [checkedOptions1, setcheckedOptions1] = useState(false);
  const [checkedOptions2, setcheckedOptions2] = useState(false);
  const latitude: any = sessionStorage.getItem("latitude");
  const longitude: any = sessionStorage.getItem("longitude");

  const UpdateMobile = {
    mobile: "",
    otp: "",
  };

  const UpdateEmail = {
    email: "",
    otp: "",
  };

  const type = data === "mobile" ? true : false;

  const handleOTPClick = (values: any) => {
    if (values.mobile?.length < 10) {
      setMobileErrorMessage("Enter Valid Mobile Number");
      setTimeout(() => {
        setMobileErrorMessage("");
      }, 3000);
    } else {
      let obj: any = {
        mobile: values.mobile,
        latitude: latitude,
        longitude: longitude,
        request_id: value,
      };
      GetMobileOTPAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          //    console.log("responseData", responseData);
          sessionStorage.setItem("emrequestid", response.data.data.request_id);
          setRequestId(response.data.data.request_id);
          setDisplayMobileOtp(true);
          setMobileResendOtp(true);

          setmobileSuccess("Otp sent Successfully");

          setTimeout(() => {
            setmobileSuccess("");
          }, 5000);
        })
        .catch((error: any) => {
          if (error && error.response.data.message)
            setmobileerror(error.response.data.message);
          setTimeout(() => {
            setmobileerror("");
          }, 5000);
        });
    }
  };
  const handleResendMobileOTPClick = (values: any) => {
    let obj: any = {
      mobile: values.mobile,
      latitude: latitude,
      longitude: longitude,
      request_id: value,
    };
    GetMobileOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setmobileSuccess("Otp sent Successfully");
        // setDisplayMobileOtp(true);
        setTimeout(() => {
          setmobileSuccess("");
        }, 5000);
      })
      .catch((error: any) => {
        if (error && error.response.data.message)
          setmobileerror(error.response.data.message);
        setTimeout(() => {
          setmobileerror("");
        }, 5000);
      });
  };
  const handleResendEmailOTPClick = (values: any) => {
    let obj: any = {
      email: values.email,
      latitude: latitude,
      longitude: longitude,
      request_id: value,
    };
    GetEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseData", responseData);

        setemailSuccess("Otp sent Successfully");
        // setDisplayMobileOtp(true);
        setTimeout(() => {
          setemailSuccess("");
        }, 5000);
      })
      .catch((error: any) => {
        // console.log("otperror", error.response.data.message);

        if (error && error.response.data.message)
          setEmailerror(error.response.data.message);
        setTimeout(() => {
          setEmailerror("");
        }, 5000);
      });
  };

  const handleEmailOTPClick = (values: any) => {
    let obj: any = {
      email: values.email,
      latitude: latitude,
      longitude: longitude,
      request_id: value,
    };

    GetEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseData", responseData);
        sessionStorage.setItem("emrequestid", response.data.data.request_id);
        setRequestId(response.data.data.request_id);
        setEmailResendOtp(true);

        setemailSuccess("Otp sent Successfully");
        setDisplayEmailOtp(true);
        setTimeout(() => {
          setemailSuccess("");
        }, 5000);
      })
      .catch((error: any) => {
        //  console.log("otperror", error.response);
        //  console.log(error.response.data.message);
        if (error && error.response.data.message)
          setEmailerror(error.response.data.message);
        setTimeout(() => {
          setEmailerror("");
        }, 5000);
      });
  };

  return (
    <BootstrapDialog
      //   onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // sx={{
      //   "&.MuiPaper-root-MuiDialog-paper":{
      //     borderRadius:'12px'
      //   }
      // }}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => {
          handleClose();
          setDisplayEmailOtp(false);
          setDisplayMobileOtp(false);
        }}
      >
        {type ? "Update Mobile Number" : "Update Email Id"}
      </BootstrapDialogTitle>
      {type ? (
        <Formik
          validationSchema={UpdateMobileSchema}
          initialValues={UpdateMobile}
          onSubmit={(values) => {
            // handleSubmitData(values, "mobile", requestId);
            // setDisplayMobileOtp(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <>
              {/* {console.log("values", values, "errors", errors)} */}
              <form noValidate onSubmit={handleSubmit}>
                <DialogContent>
                  <Box
                    component="form"
                    noValidate
                    className={styles.boxContainer}
                  >
                    <Stack spacing={2} className={styles.textFeildContainer}>
                      <Stack
                        justifyContent={"space-between"}
                        spacing={2}
                        // direction={"row"}
                      >
                        <div className={styles.textWrapper}>
                          <div className={styles.textfeild}>
                            <TextField
                              id="mobile"
                              fullWidth
                              name="mobile"
                              label="Enter New Mobile Number"
                              variant="outlined"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.mobile}
                              error={touched.mobile && Boolean(errors.mobile)}
                              helperText={
                                touched.mobile && errors.mobile?.toString()
                              }
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <span style={{ fontSize: "14px" }}>
                                      +91
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              onKeyPress={(event) => {
                                const keyCode = event.keyCode || event.which;
                                const keyValue = String.fromCharCode(keyCode);
                                const isValidKey = /^\d+$/.test(keyValue);

                                if (!isValidKey) {
                                  event.preventDefault();
                                }
                              }}
                              disabled={mobileResendOtp}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 500,
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                                maxLength: 10,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  height: "60px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827", // Label color when the field has a value
                                  },
                                },
                              }}
                            />
                            <FormHelperText
                              sx={{ color: "red", marginLeft: "15px" }}
                            >
                              {errorMobileMessage}
                            </FormHelperText>
                          </div>
                          <div className={styles.buttons}>
                            {mobileResendOtp ? (
                              <Button
                                variant="contained"
                                sx={{
                                  height: "40px",
                                  fontSize: "13px",
                                  width: "max-content",
                                }}
                                onClick={() => {
                                  handleResendMobileOTPClick(values);
                                }}
                                disabled={values.mobile?.length < 10}
                              >
                                Resend OTP
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                sx={{
                                  height: "40px",
                                  fontSize: "13px",
                                  width: "max-content",
                                }}
                                onClick={() => {
                                  handleOTPClick(values);
                                }}
                                disabled={values.mobile?.length < 10}
                              >
                                Send OTP
                              </Button>
                            )}
                          </div>
                        </div>
                        {displayMobileOtp && (
                          <TextField
                            id="otp"
                            fullWidth
                            label="Enter OTP"
                            className={styles.otpTextFeild}
                            name="otp"
                            variant="outlined"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.otp}
                            error={touched.otp && Boolean(errors.otp)}
                            helperText={touched.otp && errors.otp?.toString()}
                            onKeyPress={(event) => {
                              const keyCode = event.keyCode || event.which;
                              const keyValue = String.fromCharCode(keyCode);
                              const isValidKey = /^\d+$/.test(keyValue);

                              if (!isValidKey) {
                                event.preventDefault();
                              }
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{
                                    // borderRight: "1px solid #E5E7EB",
                                    // height: "22px",
                                    paddingRight: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <img src={otpIcon} />
                                </InputAdornment>
                              ),
                            }}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 500,
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 6,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            sx={{
                              width: "95%",
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                                height: "60px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 500,
                                "&.MuiFormLabel-filled": {
                                  color: "#111827", // Label color when the field has a value
                                },
                              },
                            }}
                          />
                        )}
                      </Stack>
                    </Stack>
                    {displayMobileOtp && (
                      <div className={styles.checkBoxSextion}>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="condition3"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#1F2937",
                                  },
                                }}
                                checked={checkedOptions2}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  setcheckedOptions2(checked);
                                }}
                              />
                            }
                            label={
                              <span className={styles.label}>
                                I/We hereby declare that the mobile number being
                                updated here belongs to me/us. Further, I
                                authorise Firstock to use this to send me any
                                information/alert/sms. This change will affect
                                the Trading and Demat account that I hold with
                                Firstock.
                              </span>
                            }
                          />
                        </FormGroup>
                      </div>
                    )}
                    {values.mobile && values.otp && checkedOptions2 ? (
                      <Button
                        onClick={() =>
                          handleSubmitData(values, "mobile", requestId)
                        }
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          height: "40px",
                          fontSize: "12px",
                          width: "100px",
                          background: "#3263E5",
                          "&:hover": {
                            background: "#3263E5",
                          },
                        }}
                      >
                        Submit
                      </Button>
                    ) : (
                      <Button
                        disabled
                        type="submit"
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          height: "40px",
                          fontSize: "12px",
                          width: "100px",
                        }}
                      >
                        Submit
                      </Button>
                    )}
                  </Box>
                </DialogContent>
                <SucessSnackBar message={mobileSuccess} />
                <SnackBar message={mobileError} />
              </form>
            </>
          )}
        </Formik>
      ) : (
        <Formik
          validationSchema={UpdateEmailSchema}
          initialValues={UpdateEmail}
          onSubmit={(values) => {
            // console.log("values", values);
            // handleSubmitData(values, "email", requestId);
            // setDisplayEmailOtp(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <>
              {/* {console.log("values", values, "errors", errors)} */}
              <form noValidate onSubmit={handleSubmit}>
                <DialogContent>
                  <Box
                    component="form"
                    noValidate
                    className={styles.boxContainer}
                  >
                    <Stack spacing={2} className={styles.textFeildContainer}>
                      <Stack
                        justifyContent={"space-between"}
                        spacing={2}
                        // direction={"row"}
                      >
                        <div className={styles.textWrapper}>
                          <div className={styles.textfeild}>
                            <TextField
                              id="email"
                              fullWidth
                              name="email"
                              label="Enter New Email Id"
                              variant="outlined"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              error={touched.email && Boolean(errors.email)}
                              helperText={
                                touched.email && errors.email?.toString()
                              }
                              disabled={emailResendOtp}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 500,
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  height: "60px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827", // Label color when the field has a value
                                  },
                                },
                              }}
                            />
                            <FormHelperText
                              sx={{ color: "red", marginLeft: "15px" }}
                            >
                              {errorEmailMessage}
                            </FormHelperText>
                          </div>
                          <div className={styles.buttons}>
                            {emailResendOtp ? (
                              <Button
                                variant="contained"
                                sx={{
                                  height: "40px",
                                  fontSize: "13px",
                                  width: "max-content",
                                }}
                                onClick={() => {
                                  handleResendEmailOTPClick(values);
                                }}
                                disabled={
                                  errors.email || values.email?.length < 6
                                    ? true
                                    : false
                                }
                              >
                                Resend OTP
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                sx={{
                                  height: "40px",
                                  fontSize: "13px",
                                  width: "max-content",
                                }}
                                onClick={() => {
                                  handleEmailOTPClick(values);
                                }}
                                disabled={
                                  errors.email || values.email?.length < 6
                                    ? true
                                    : false
                                }
                              >
                                Send OTP
                              </Button>
                            )}
                          </div>
                        </div>
                        {displayEmailOtp && (
                          <TextField
                            id="otp"
                            fullWidth
                            className={styles.otpTextFeild}
                            placeholder="Enter OTP"
                            name="otp"
                            variant="outlined"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.otp}
                            error={touched.otp && Boolean(errors.otp)}
                            helperText={touched.otp && errors.otp?.toString()}
                            onKeyPress={(event) => {
                              const keyCode = event.keyCode || event.which;
                              const keyValue = String.fromCharCode(keyCode);
                              const isValidKey = /^\d+$/.test(keyValue);

                              if (!isValidKey) {
                                event.preventDefault();
                              }
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{
                                    // borderRight: "1px solid #E5E7EB",
                                    // height: "22px",
                                    paddingRight: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <img src={otpIcon} />
                                </InputAdornment>
                              ),
                            }}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 500,
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 6,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            sx={{
                              width: "95%",
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                                height: "60px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 500,
                                "&.MuiFormLabel-filled": {
                                  color: "#111827", // Label color when the field has a value
                                },
                              },
                            }}
                          />
                        )}
                      </Stack>
                    </Stack>
                    {displayEmailOtp && (
                      <div className={styles.checkBoxSextion}>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="condition3"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#1F2937",
                                  },
                                }}
                                checked={checkedOptions1}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  setcheckedOptions1(checked);
                                }}
                              />
                            }
                            label={
                              <span className={styles.label}>
                                I/We hereby declare that the email ID being
                                updated here belongs to me/us. Further, I
                                authorise Firstock to use this to send me any
                                information/alert/email. This change will affect
                                the Trading and Demat account that I hold with
                                Firstock.
                              </span>
                            }
                          />
                        </FormGroup>
                      </div>
                    )}
                    {values.email && values.otp && checkedOptions1 ? (
                      <Button
                        onClick={() =>
                          handleSubmitData(values, "email", requestId)
                        }
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          height: "40px",
                          fontSize: "12px",
                          width: "100px",
                          background: "#3263E5",
                          "&:hover": {
                            background: "#3263E5",
                          },
                        }}
                      >
                        Submit
                      </Button>
                    ) : (
                      <Button
                        disabled
                        type="submit"
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          height: "40px",
                          fontSize: "12px",
                          width: "100px",
                        }}
                      >
                        Submit
                      </Button>
                    )}
                  </Box>
                </DialogContent>

                <SucessSnackBar message={emailSuccess} />
                <SnackBar message={emailError} />
              </form>
            </>
          )}
        </Formik>
      )}
    </BootstrapDialog>
  );
}
